import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import { storageKey } from "@/site";

export const LAST_READER_KEY = storageKey("lastReader.v1");

type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;

const browserStorage = (): Store | null => {
  try {
    return localStorage;
  } catch {
    return null;
  }
};

/**
 * The reader this device last read as. A sign-in that ends without a
 * reader replaces the device's reader_session, and this is how the device
 * gets back to it, with whatever its outbox still holds.
 */
export function rememberLastReader(
  readerId: string,
  storage: Store | null = browserStorage(),
): void {
  storage?.setItem(LAST_READER_KEY, readerId);
}

export function lastReader(
  storage: Store | null = browserStorage(),
): string | null {
  const stored = storage?.getItem(LAST_READER_KEY) ?? null;
  return stored !== null && UUID_REGEX.test(stored) ? stored : null;
}

export function forgetLastReader(
  readerId: string,
  storage: Store | null = browserStorage(),
): void {
  if (lastReader(storage) === readerId) storage?.removeItem(LAST_READER_KEY);
}
